// API URL - 개발/운영 환경 자동 감지
export const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // 프로덕션: Nginx 프록시 사용
  : 'http://192.168.219.200:5000/api';  // 개발: 백엔드 직접 연결

// 날짜 포맷 함수
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// 금액 포맷 함수
export function formatMoney(num) {
  if (!num && num !== 0) return '';
  // 문자열이면 parseFloat로 소수점 처리
  const parsedNum = typeof num === 'string' ? parseFloat(num) : num;
  if (isNaN(parsedNum)) return '';
  return Math.floor(parsedNum).toLocaleString('ko-KR') + '원';
}

// 필드명 한글 변환
export function getFieldName(field) {
  const names = {
    'receipt_date': '접수일',
    'receipt_details': '접수내역',
    'process_details': '처리내역',
    'completion_date': '완료일',
    'labor_cost': '공임',
    'total_cost': '전체비용',
    '합계금액': '합계금액',
    'payment_method': '결제방식',
    'progress_status': '진행상태',
    'notes': '비고',
    '자재추가': '자재추가',
    '자재삭제': '자재삭제'
  };
  return names[field] || field;
}

/** * 추가된 부분: useRecords.js에서 참조하는 에러 메시지 객체 
 */
export const MSG = {
  FETCH_ERROR: '데이터를 불러오는 중 오류가 발생했습니다.',
  SAVE_SUCCESS: '저장되었습니다.',
  DELETE_CONFIRM: '정말 삭제하시겠습니까?',
  AUTH_REQUIRED: '로그인이 필요한 서비스입니다.'
};
